export let projectVisibilityTag = {
  bindings: {
    project: '<'
  },
  template: `
    <div class="text-xxs projectTypeTag projectVisibilityTag font-bold text-block text-color-w" ng-class="proVisibilityVM.tagClass(proVisibilityVM.project)">
      <p class="text-block no-margin">{{ proVisibilityVM.project.namecCommunicationRegister }}</p>
    </div>`,
  controllerAs: 'proVisibilityVM',
  controller: ['Validations', 'Ramda',
  function projectVisibilityCtrl (Validations, Ramda) {
    const R = Ramda

    const isBlue = R.curry((lib, project) => {
      return lib.isCrossProject(project)
    })

    const isPurple = R.curry((lib, project) => {
      return lib.isInternalProject(project)
    })

    const tagClass = R.curry((lib, project) => {
      
      switch (true) {
        case isBlue(lib, project):
          return 'azul'
        case isPurple(lib, project):
          return 'morado'
        default:
          return 'naranjo'
      }
    })

    this.tagClass = tagClass(Validations)
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/visibility/list/projects/project-visibility-tag.js